import variables from '../variables';
import mixins from '../mixins';

export default {
    rootDefault: {
        position: 'relative',
        marginTop: 4,
        marginBottom: 24,
        backgroundColor: variables.white,

        '&.filled': {
            '& $placeholder': {
                fontSize: 12,
                top: 4,
                lineHeight: '20px',
                transform: 'none',
                zIndex: 3
            },

            '& $inputDefault': {
                padding: '24px 35px 8px 12px',
            }
        },

        '&.focused': {
            '& $inputDefault': {
                borderColor: ({themeColor}) => themeColor || variables.lime,
            }
        },

        '&.error': {
            '& $inputDefault': {
                borderColor: variables.red,
                color: variables.red,
            }
        },

        '&.disabled': {
            backgroundColor: variables.black06,

            '& $inputDefault': {
                border: 'none',
            }
        }
    },

    inputDefault: {
        caretColor: ({themeColor}) => themeColor || variables.lime,
        height: 56,
        position: 'relative',
        backgroundColor: 'transparent',
        zIndex: 2,
        padding: '0 20px 0 12px',
        width: '100%',
        boxSizing: 'border-box',
        fontSize: 16,
        color: variables.black87,
        lineHeight: '24px',
        border: `1px solid ${variables.black12}`,
        fontWeight: 400,
        borderRadius: 0,
        appearance: 'none',
        textOverflow: 'ellipsis',

        '&:read-only': {
            cursor: 'pointer',
        },

        '&:active, &:focus': {
            outline: 'none',
        }
    },

    placeholder: {
        fontSize: 16,
        position: 'absolute',
        zIndex: 1,
        left: 12,
        color: variables.black54,
        transition: 'all .2s',
        ...mixins.centerVertical,
    },

    suggestionsContainer: {
        padding: 4,
        position: 'absolute',
        bottom: -4,
        transform: 'translateY(100%)',
        backgroundColor: variables.white,
        border: `1px solid ${variables.black12}`,
        width: '100%',
        zIndex: 50,

        '&:after, &:before': {
            content: '""',
            position: 'absolute',
            width: 0,
            height: 0,
            borderStyle: 'solid',
        },

        '&:after': {
            left: 21,
            top: -10,
            borderWidth: 5,
            borderColor: `transparent transparent ${variables.white} transparent`,
        },

        '&:before': {
            left: 20,
            top: -12,
            borderWidth: 6,
            borderColor: `transparent transparent ${variables.black12} transparent`,
        }
    },

    suggestItemDefault: {
        lineHeight: '20px',
        padding: '8px 12px',
        fontSize: 12,
        cursor: 'pointer',
        color: variables.black87,
        display: 'flex',
        justifyContent: 'space-between',

        '&.selected': {
            color: variables.white,
            backgroundColor: ({themeColor}) => themeColor || variables.lime,
        }
    },

    suggestItemValueDefault: {
        color: variables.black54,
        marginRight: 8,
        fontSize: 14,
    },

    trailingIconDefault: {
        boxSizing: 'content-box',
        width: 20,
        height: 20,
        right: -4,
        zIndex: 5,
        padding: 20,
        cursor: 'pointer',
        ...mixins.centerVertical,

        '& svg': {
            pointerEvents: 'none',
            fill: ({themeColor}) => themeColor || variables.lime,
        }
    },

    base: {
        position: 'relative',
        marginBottom: -16,
    },

    error: {
        position: 'absolute',
        top: -4,
        left: -4,
        right: -4,
        boxShadow: '0 0 0 1px rgba(6,44,82,0.1), 0 2px 16px 0 rgba(33,43,54,0.08)',
        fontSize: 12,
        lineHeight: '14px',
        color: variables.black87,
        padding: '64px 20px 4px 15px',
        zIndex: 1,
        backgroundColor: '#FAFAFA',
    },

    fakeError: {
        visibility: 'hidden',
        marginBottom: -24,
        display: 'inline-block',
    },

    scrollTrack: {
        position: 'absolute',
        width: '8px !important',
        right: 0,
        bottom: 0,
        top: 0,
        paddingLeft: 3,
        borderLeft: `1px solid ${variables.black12}`,
        backgroundColor: variables.white,
    },

    scrollThumb: {
        cursor: 'pointer',
        borderRadius: 15,
        backgroundColor: variables.black38,
    },
}
